import * as yup from 'yup';

/* 
To use this you must import it in the file you want to use it in as well as the yup validation e.g.
import * as Yup from 'yup';
import '@discover-lib/validationExtensions';

otherwise the form will not work and you will get errors
*/

yup.addMethod<yup.StringSchema>(
  yup.string,
  'noHtml',
  function (message = 'HTML tags are not allowed') {
    return this.test(
      'no-html',
      message,
      (value) =>
        // allow empty (other rules like .required() still apply), but block any tag-like sequences
        value == null || !/<\/?[a-z][\s\S]*>/i.test(value)
    );
  }
);

// declare the TS signature so `.noHtml()` is recognized
declare module 'yup' {
  interface StringSchema {
    noHtml(message?: string): StringSchema;
  }
}
